import { render, staticRenderFns } from "./RechargeGift.vue?vue&type=template&id=5143e40b&scoped=true&"
import script from "./RechargeGift.vue?vue&type=script&lang=js&"
export * from "./RechargeGift.vue?vue&type=script&lang=js&"
import style0 from "./RechargeGift.vue?vue&type=style&index=0&id=5143e40b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5143e40b",
  null
  
)

export default component.exports